{
  "panel": {
    "title": "Notes",
    "newNote_title": "Nouvelle note",
    "search_placeholder": "Rechercher des notes…",
    "search_aria": "Rechercher des notes",
    "clearSearch_aria": "Effacer la recherche",
    "editorPlaceholder": "À quoi pensez-vous…",
    "titleInput_placeholder": "Sans titre",
    "untitled": "Sans titre",
    "emptyNote": "Note vide",
    "loadingNotes": "Chargement des notes…",
    "noNotesYet": "Aucune note pour l'instant. Touchez + pour en créer une.",
    "noResults": "Aucun résultat pour « {{query}} »",
    "noNotesTagged": "Aucune note étiquetée {{tag}}",
    "tagFilterAll": "Toutes",
    "filterByTag_aria": "Filtrer par étiquette",
    "templates": "Modèles",
    "editorTheme_aria": "Thème de l'éditeur",
    "themeActive_aria": "Thème {{theme}} (actif)",
    "theme_aria": "Thème {{theme}}",
    "themeName": {
      "dark": "Sombre",
      "sepia": "Sépia",
      "light": "Clair",
      "forest": "Forêt"
    },
    "voice": "Voix",
    "voice_title": "Note vocale",
    "voiceUnavailable_title": "Reconnaissance vocale indisponible dans ce navigateur",
    "openVoiceRecorder_aria": "Ouvrir l'enregistreur de note vocale",
    "summarizing_title": "Résumé en cours…",
    "summarize_title": "Résumer",
    "summarizeNote_aria": "Résumer la note",
    "aiCommands_title": "Commandes IA  Cmd+K",
    "openAiPalette_aria": "Ouvrir la palette de commandes IA",
    "enterFocusMode_title": "Mode concentration  Cmd+Shift+F",
    "exitFocusMode_title": "Quitter le mode concentration  Cmd+Shift+F",
    "enterFocusMode_aria": "Activer le mode concentration",
    "exitFocusMode_aria": "Quitter le mode concentration",
    "export_title": "Exporter la note",
    "delete_title": "Supprimer la note",
    "delete_aria": "Supprimer la note",
    "moreActions_title": "Plus d'actions",
    "wordCount_one": "{{formatted}} mot · ~{{minutes}} min de lecture",
    "wordCount_other": "{{formatted}} mots · ~{{minutes}} min de lecture",
    "referencedBy_one": "Référencée par {{count}}",
    "referencedBy_other": "Référencée par {{count}}",
    "noMatchingNotes": "Aucune note correspondante",
    "mobileTabs_aria": "Vue des notes",
    "mobileTabNotes": "Notes",
    "mobileTabEditor": "Éditeur",
    "saveFailed": "Échec de l'enregistrement de la note : {{message}}",
    "deleteFailed": "Échec de la suppression de la note",
    "loadFailed": "Échec du chargement des notes",
    "analyzeFailed": "Échec de l'analyse de la note",
    "aiCommandFailed": "Échec de la commande IA",
    "unknownError": "Erreur inconnue"
  },
  "paywall": {
    "title": "Les notes font partie de Rhemn Pro",
    "safariBody": "Débloquez les notes synchronisées, la dictée et les résumés IA avec Rhemn Pro. Déjà membre ? Tout se débloque automatiquement à la connexion.",
    "body": "Débloquez les notes synchronisées, la dictée dans le navigateur et les résumés IA structurés."
  },
  "format": {
    "bold": "Gras",
    "italic": "Italique",
    "strikethrough": "Barré",
    "inlineCode": "Code en ligne",
    "heading1": "Titre 1",
    "heading2": "Titre 2",
    "heading3": "Titre 3",
    "bulletList": "Liste à puces",
    "numberedList": "Liste numérotée",
    "blockquote": "Citation",
    "codeBlock": "Bloc de code",
    "toggleBold_aria": "Activer le gras",
    "toggleItalic_aria": "Activer l'italique",
    "toggleStrikethrough_aria": "Activer le barré",
    "toggleInlineCode_aria": "Activer le code en ligne",
    "toggleBulletList_aria": "Activer la liste à puces",
    "toggleNumberedList_aria": "Activer la liste numérotée",
    "toggleBlockquote_aria": "Activer la citation",
    "formatOptions_aria": "Options de mise en forme"
  },
  "analysis": {
    "heading": "Résumé",
    "onDevice": "⚡ Sur l'appareil",
    "onDevice_aria": "Traité sur l'appareil",
    "applyToNote_title": "Appliquer à la note",
    "applyToNote_aria": "Appliquer le résumé à la note",
    "summaryLabel": "Résumé",
    "keyPointsLabel": "Points clés",
    "noKeyPoints": "Aucun point clé retourné pour cette note."
  },
  "export": {
    "markdown": "Exporter en Markdown",
    "plainText": "Exporter en texte brut",
    "pdf": "Exporter en PDF",
    "allZip": "Tout exporter en ZIP",
    "label": "Exporter"
  },
  "cmdk": {
    "dialog_aria": "Palette de commandes IA",
    "input_placeholder": "Demandez à l'IA ou lancez une commande…",
    "esc": "Esc",
    "back_aria": "Retour",
    "translateTo": "Traduire en",
    "language_placeholder": "Langue…",
    "aiActions": "Actions IA",
    "noCommandsMatch": "Aucune commande ne correspond à « {{query}} »",
    "continue": {
      "label": "Poursuivre la rédaction",
      "description": "Reprendre là où vous vous êtes arrêté"
    },
    "summarize": {
      "label": "Résumer la sélection",
      "description": "Condenser en points clés"
    },
    "formal": {
      "label": "Rendre ceci formel",
      "description": "Élever le ton vers un registre professionnel"
    },
    "simplify": {
      "label": "Simplifier",
      "description": "Langage plus court et plus clair"
    },
    "translate": {
      "label": "Traduire en…",
      "description": "Traduire dans une autre langue"
    },
    "expand": {
      "label": "Développer cette puce",
      "description": "Transformer la puce sélectionnée en prose"
    },
    "languages": {
      "Spanish": "Espagnol",
      "Arabic": "Arabe",
      "French": "Français",
      "German": "Allemand",
      "Japanese": "Japonais",
      "Portuguese": "Portugais"
    }
  },
  "templates": {
    "dialog_aria": "Choisir un modèle",
    "header": "Choisir un modèle",
    "builtInLabel": "Intégrés",
    "myTemplatesLabel": "Mes modèles",
    "saveCurrent": "Enregistrer la note actuelle comme modèle",
    "myTemplatesEmpty": "Vos modèles enregistrés apparaîtront ici",
    "useTemplate": "Utiliser le modèle",
    "meeting": {
      "name": "Notes de réunion",
      "description": "Consigner les décisions et les actions",
      "structure": "Participants / Ordre du jour / Notes / Actions"
    },
    "journal": {
      "name": "Journal quotidien",
      "description": "Réfléchir à votre journée",
      "structure": "Gratitude / Réussites du jour / Notes"
    },
    "book": {
      "name": "Résumé de livre",
      "description": "Capturer les idées clés d'un livre",
      "structure": "Idée centrale / Citations clés / Enseignements"
    },
    "project": {
      "name": "Brief de projet",
      "description": "Définir la portée, les objectifs et les parties prenantes",
      "structure": "Objectif / Portée / Risques / Échéancier"
    },
    "brainstorm": {
      "name": "Brainstorming",
      "description": "Capture libre d'idées",
      "structure": "Sujet / Idées / Prochaines étapes"
    },
    "weekly": {
      "name": "Bilan hebdomadaire",
      "description": "Faire le point et planifier votre semaine",
      "structure": "Réussites / Difficultés / Axes de concentration"
    }
  },
  "voice": {
    "dialog_aria": "Enregistreur de note vocale",
    "cancel_aria": "Annuler",
    "statusRecording": "Enregistrement",
    "statusTranscribing": "Transcription…",
    "statusReview": "Relecture",
    "skip": "Passer",
    "mark": "Marquer",
    "mark_title": "Déposer un repère temporel",
    "captureMeeting": "Capturer la réunion",
    "captureMeeting_title": "Capturer aussi l'audio d'un onglet de réunion",
    "meeting": "Réunion",
    "meeting_title": "Capture de l'onglet de réunion",
    "markers_aria": "Repères temporels",
    "listening": "Écoute…",
    "micDenied": "L'accès au micro est désactivé. Autorisez-le dans Réglages, puis réessayez.",
    "captureFailed": "L'enregistrement n'a pas pu démarrer. Réessayez dans un instant.",
    "tabPicker_aria": "Choisir un onglet de réunion à capturer",
    "captureFrom": "Capturer l'audio depuis…",
    "noAudibleTab": "Aucun onglet ne diffuse d'audio. Ouvrez votre réunion et assurez-vous que quelqu'un parle, puis réessayez.",
    "tabPickerCancel": "Annuler",
    "tabTranscript": "Transcription",
    "structuring": "Structuration…",
    "structuredNote": "Note structurée",
    "structureFailed": "Impossible de créer la note structurée.",
    "retryStructure": "Réessayer",
    "browserTranscript": "Transcription du navigateur",
    "nothingCaptured": "Rien n'a été capturé.",
    "buildingStructured": "Création de la note structurée…",
    "cancel": "Annuler",
    "stop": "Arrêter",
    "recordAgain": "Réenregistrer",
    "saveToNote": "Enregistrer dans la note",
    "statusMeeting": "Réunion",
    "captureStrip_aria": "Capture de l'audio de {{tab}}",
    "stopCapture": "Arrêter la capture",
    "stopCapture_title": "Arrête la capture de l'onglet — votre micro continue d'enregistrer",
    "stopsIn": "Arrêt dans {{time}}",
    "autoStopped": "Enregistrement arrêté à la limite de 60 minutes.",
    "autoStoppedQuota": "Enregistrement arrêté — vous avez utilisé les minutes de transcription de ce mois.",
    "captureLost": "L'onglet de la réunion s'est fermé. Votre micro enregistre toujours.",
    "tabSummary": "Résumé",
    "noSpeakers": "Intervenants non identifiés",
    "speakerN": "Intervenant {{number}}",
    "renameSpeaker_aria": "Renommer {{name}} — s'applique à toutes ses interventions",
    "renameSpeaker_input_aria": "Nom de l'intervenant",
    "turnTime_title": "Dit à {{time}}",
    "actionItemsTitle": "Actions à suivre",
    "actionsCount": "{{checked}} sur {{total}}",
    "addToTasks_one": "Ajouter {{count}} aux Tâches",
    "addToTasks_other": "Ajouter {{count}} aux Tâches",
    "addToTasksZero": "Ajouter aux Tâches",
    "adding": "Ajout…",
    "tasksAdded_one": "{{count}} tâche ajoutée",
    "tasksAdded_other": "{{count}} tâches ajoutées",
    "viewTasks": "Voir",
    "addFailed": "Échec de l'ajout — réessayez.",
    "minutesLeft_one": "{{count}} min restante",
    "minutesLeft_other": "{{count}} min restantes",
    "minutesLeftShort_one": "{{count}} min restante",
    "minutesLeftShort_other": "{{count}} min restantes",
    "minutesLeft_title": "{{count}} minutes de transcription restantes ce mois-ci",
    "quotaExhausted": "Vous avez utilisé les minutes de réunion de ce mois. Elles se renouvellent le {{date}}.",
    "quotaUnknown": "Minutes restantes inconnues — l'enregistrement peut atteindre votre limite mensuelle",
    "meetingProRequired": "La transcription de réunion fait partie de Pro. Votre transcription en direct est conservée ci-dessous.",
    "gateTitle": "Enregistrement de réunion",
    "gateBody": "Enregistrez l'onglet d'une réunion avec votre micro — intervenants identifiés et actions extraites. Inclus avec Pro.",
    "gateLater": "Pas maintenant",
    "gateCta": "Voir Pro",
    "roomOption": "Aucun onglet — enregistrer la pièce",
    "roomHint": "Un appel sur haut-parleur, une app native ou des personnes dans la pièce — tout ce que vous entendez à voix haute.",
    "roomHint_title": "Si l'autre partie est dans vos écouteurs, le micro ne peut pas l'entendre — utilisez le haut-parleur.",
    "recordRoom": "Enregistrer la pièce",
    "recordRoom_title": "Enregistre tous ceux que le micro entend — intervenants identifiés",
    "roomStart": "Démarrer",
    "statusRoom": "Pièce",
    "roomStrip": "Enregistrement de la pièce",
    "roomStrip_aria": "Enregistrement de la pièce — tous ceux que le micro entend",
    "roomOff": "Désactiver",
    "roomOff_title": "Désactive le mode pièce — ceci redevient une note vocale ordinaire",
    "roomRenameHint": "Touchez un nom pour le renommer — l'un d'eux, c'est vous.",
    "gateBodyRoom": "Enregistrez ce qui se dit autour de vous — intervenants identifiés et actions extraites. Inclus avec Pro.",
    "roomHintDevice": "Les appels sur cet appareil ne peuvent pas être enregistrés — iOS les garde privés. Un autre téléphone sur haut-parleur, ou une conversation dans la pièce, fonctionne.",
    "autoStoppedSize": "Enregistrement arrêté à la limite de taille d'envoi.",
    "tooLarge": "L'enregistrement était trop volumineux pour être envoyé, il n'a donc pas pu être transcrit.",
    "destTo": "Dans",
    "dest_aria": "Ajouter à la liste : {{name}}",
    "destMenu_aria": "Choisir une liste",
    "destNewPending_aria": "Nouvelle liste : {{name}}"
  },
  "meetingNotice": {
    "title": "Vos réunions, dans vos notes",
    "body": "Rhemn peut désormais enregistrer un onglet de réunion que vous choisissez — uniquement pendant l'enregistrement d'une note vocale, et uniquement l'onglet que vous sélectionnez.",
    "factPrivacy": "L'audio est traité pour créer votre transcription, puis supprimé. Les enregistrements ne sont jamais conservés.",
    "factControl": "Rien n'est capturé tant que vous n'appuyez pas sur enregistrer et ne choisissez pas un onglet.",
    "cta": "Compris",
    "privacyLink": "Lire notre politique de confidentialité",
    "dialog_aria": "À propos de la nouvelle autorisation d'enregistrement de réunion"
  }
}
